import { render, staticRenderFns } from "./LayoutWithoutSidenav.vue?vue&type=template&id=1586a0e3&"
import script from "./LayoutWithoutSidenav.vue?vue&type=script&lang=js&"
export * from "./LayoutWithoutSidenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports